import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Component({
    selector: 'pr-comparaison-v2',
    templateUrl: './pr-comparaison-v2.component.html',
    styleUrls: ['./pr-comparaison-v2.component.scss'],
    standalone: false
})
export class PrComparaisonV2Component implements OnInit, OnChanges {
  numero = 0;
  @Input() simulation: any;
  rows = [
    { title: '', icon: '', label: 'header' },
    {
      title: "Montant de l'investissement",
      icon: 'sp-money-simu',
      label: 'investedAmount',
      tooltip: '',
      type: 'currency',
    },
    {
      title: "Réduction d'impôts",
      icon: 'sp-simu-bal',
      label: 'directTaxReduction',
      tooltip: '',
      type: 'currency',
      colored: true,
    },
    {
      title: 'Montant capitalisable',
      icon: 'sp-simu-cash',
      label: 'capitalizableAmount',
      tooltip: '',
      type: 'currency',
    },

    {
      title: 'Capital au terme',
      icon: 'sp-money-simu',
      label: 'endCapital',
      tooltip: '',
      type: 'currency',
      colored: true,
    },
    {
      title: 'Total impôts à la sortie',
      icon: 'sp-simu-bal',
      label: 'totalTax',
      tooltip: '',
      type: 'currency',
      coloredAv: true,
    },
    {
      title: 'Capital disponible',
      icon: 'sp-graph',
      label: 'availableCapital',
      tooltip: '',
      type: 'currency',
      colored: true,
    },
    {
      title: 'TRI (taux de rentabilité interne)',
      icon: 'sp-graph',
      label: 'internalRateOfReturn',
      tooltip: '',
      type: 'percentByYear',
      colored: true,
    },
  ];
  columns = ['PER', 'ASSURANCE_VIE'];
  col;

  constructor() {}

  ngOnInit(): void {
    const comparaisons = this.simulation.result.lifeInsuranceComparison;
    this.formatData(comparaisons);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.simulation) {
      this.formatData(
        changes.simulation.currentValue.result.lifeInsuranceComparison,
      );
    }
  }

  private formatData(comparison) {
    const category = ['per', 'lifeInsurance'];
    const formattedData = [];
    category.forEach(cat => {
      const categoryData = comparison[cat];
      const formattedCategory = {
        recommanded: cat == 'per' ? true : false,
        header: cat == 'per' ? 'PER' : 'Assurance-vie',
        capitalizableAmount: categoryData.capitalizableAmount,
        directTaxReduction: categoryData.directTaxReduction,
        investedAmount: categoryData.investedAmount,
        endCapital: categoryData.endCapital,
        totalTax: categoryData.totalTax,
        availableCapital: categoryData.availableCapital,
        internalRateOfReturn: categoryData.internalRateOfReturn,
      };
      formattedData.push(formattedCategory);
    });
    this.col = formattedData;
  }

  val(row: any, col: any) {
    return col[row.label];
  }
  display(slide: number | 'next' | 'previous') {
    if (!isNaN(Number(slide))) this.numero = Number(slide);
    else if (slide == 'next' && this.numero < this.col.length - 1)
      this.numero += 1;
    else if (slide == 'previous' && this.numero > 0) this.numero -= 1;
  }
  classBg(row: any, scenario: any) {
    if (
      row.colored &&
      typeof row.colored == 'boolean' &&
      scenario.header == 'PER'
    ) {
      let value = this.val(row, scenario);
      if (!isNaN(value)) return value >= 0 ? 'bg-pos' : 'bg-neg';
    }

    if (
      row.coloredAv &&
      typeof row.coloredAv == 'boolean' &&
      scenario.header == 'Assurance-vie'
    ) {
      let value = this.val(row, scenario);
      if (!isNaN(value)) return value >= 0 ? 'bg-pos' : 'bg-neg';
    }

    return '';
  }
  get translation() {
    let x = this.numero * -50;
    return 'translateX(' + x + '%)';
  }
}
